// refer PULSE_SURVEY_CREATE_STATUS in ProjectConstants
export const SURVEY_STATUS = {
  DRAFT: 'DRAFT',
  IN_PROGRESS: 'IN_PROGRESS',
  PUBLISHED: 'PUBLISHED',
} as const;

export const SURVEY_STATUS_LABELS = {
  [SURVEY_STATUS.DRAFT]: 'Draft',
  [SURVEY_STATUS.IN_PROGRESS]: 'Active',
  [SURVEY_STATUS.PUBLISHED]: 'Completed',
} as const;

export const SURVEY_STATUS_COLORS = {
  [SURVEY_STATUS.DRAFT]: {
    text: '#985208',
    bg: '#E2960029',
  },
  [SURVEY_STATUS.IN_PROGRESS]: {
    text: '#0D819F',
    bg: '#CAE8F0',
  },
  [SURVEY_STATUS.PUBLISHED]: {
    text: '#235826',
    bg: '#2D8C3229',
  },
};

export type SurveyList = {
  id: number;
  name: string;
  surveyDrivers: string[];
  currentStage: keyof typeof SURVEY_STATUS;
  lastEnabledSection: string;
}[];
